export const EvaBrandMediaTypesEnum = {
    SingleImage: {
        key: 0,
        value: 'single-image',
    },
    MultipleImages: {
        key: 1,
        value: 'multiple-images',
    },
    SingleVideo: {
        key: 2,
        value: 'single-video',
    },
    MultipleVideos: {
        key: 3,
        value: 'multiple-videos',
    },
};
